<template>
  <div>
    <div>
      <div class="matrix-scale" v-for="(rowItem, id) of rowData.questionDetails.issue.rows" :key="id">
        <h4 v-html="transformHtml(rowItem.content.richText)" />
        <template v-for="(col, idx) in rowData.questionDetails.issue.items">
          <div class="flex justify-start">
            <!-- <h5 class="flex-shrink-0">{{ col.content.text }}</h5> -->
            <h5 v-html="transformHtml(col.content.richText)" />
            <el-input
              v-model="getMatrixInput(rowItem, col).model"
              placeholder="请填写"
              @input="changeMatrixInput($event, rowItem, col)"
            ></el-input>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import '../public/style.css'
import mixins from '../mixins'
import { changeMatrixInput, saveArr } from '../public/index.js'

export default {
  mixins: [mixins],
  name: 'MatrixFill',
  props: {
    rowData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    // 需要更新的 数组
    updateArr: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  inject: ['transformHtml'],
  methods: {
    // 矩阵填空题 input事件
    changeMatrixInput,
    saveArr
  }
}
</script>

<style lang="scss" scoped></style>
